import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function ProductGridSkeleton({ count = 8 }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {[...Array(count)].map((_, i) => (
        <div key={`sk-${i}`} className="space-y-2">
          <Skeleton className="aspect-[3/4] w-full bg-black/5" />
          <Skeleton className="h-4 w-3/4 bg-black/5" />
          <Skeleton className="h-4 w-1/3 bg-black/5" />
        </div>
      ))}
    </div>
  );
}
